import * as types from "../../actions/types";

export const initialState = {
    lstEmployee: [],
    employeeDetail: {},
    total: 0,
    pageSize: 0,
    pageNum: 0,
    data: {},
    isFilter: false,
    dataItemExcuting: {
        generalInfos: {},
        allowedLocations: [],
        statusChange: {
            imgRecognizeSrc: false,
            avatarSrc: false,
        },
        imgRecognizeSrc: "",
        avatarSrc: "",
    },
};

export default function employeeReducer(state = initialState, action) {
    switch (action.type) {
        case types.EMPLOYEE_STATUS_CHANGE_EMPLOYEE_DATA:
            return {
                ...state,
                dataItemExcuting: {
                    ...state.dataItemExcuting,
                    statusChange: {
                        ...state.dataItemExcuting.statusChange,
                        ...action.payload
                    }
                }
            }
        case types.EMPLOYEE_CHANGE_ALLOWED_LOCATIONS: 
            return {
                ...state,
                dataItemExcuting: {
                    ...state.dataItemExcuting,
                    allowedLocations: action.payload.lstLocations
                }
            }
        case types.EMPLOYEE_CHANGE_GENERAL_INFOS:
            return {
                ...state,
                dataItemExcuting: {
                    ...state.dataItemExcuting,
                    generalInfos: {
                        ...state.dataItemExcuting.generalInfos,
                        ...action.payload
                    }
                }
            }
        case types.EMPLOYEE_ADD_AVATAR:
            return {
                ...state,
                dataItemExcuting: {
                    ...state.dataItemExcuting,
                    avatarSrc: action.payload.imgSrc
                }
            }
        case types.EMPLOYEE_ADD_IMG_RECONIZE:
            return {
                ...state,
                dataItemExcuting: {
                    ...state.dataItemExcuting,
                    imgRecognizeSrc: action.payload.imgSrc
                }
            }
        case types.EMPLOYEE_RESET_STATE:
            return {
                ...state,
                [action.payload.fieldName]: initialState[action.payload.fieldName]
            };
        case types.GET_FILTER_EMPLOYEE:{
            return {
                ...state,
                lstEmployee:action.data.Data?action.data.Data:[],
                total: action.data.Total || 0,
                isFilter: action.isFilter,
                err:'',
                type:action.type,
            }
        }
        case types.GET_FILTER_EMPLOYEE_ERROR:{
            return {
                ...state,
                // lstEmployee:[],
                // total: 0,
                err:action.error,
                type:action.type,
            }
        }
        case types.GET_EMPLOYEE:{
            return {
                ...state,
                employeeDetail:action.data.User,
                err:'',
                type:action.type,
                data:{},
            }
        }
        case types.REFRESH_EMPLOYEE_DETAIL:{
            return {
                ...state,
                employeeDetail:{},
                err:'',
                type:action.type,
            }
        }
        case types.GET_EMPLOYEE_ERROR:{
            return {
                ...state,
                employeeDetail:{},
                err:action.error,
                type:action.type,
            }
        }
        case types.ADD_EMPLOYEE:
        case types.UPDATE_EMPLOYEE:
        case types.SET_ACTIVE_EMPLOYEE:{
            return {
                ...state,
                data:action.data,
                err:'',
                type:action.type,
            }
        }
        case types.ADD_EMPLOYEE_ERROR:
        case types.UPDATE_EMPLOYEE_ERROR:
        case types.SET_ACTIVE_EMPLOYEE_ERROR:{
            return {
                ...state,
                data:action.data,
                err:action.error,
                type:action.type,
            }
        }

        default:
            return state;
    }
}
